import date from './date';
import currency from './currency';
import phone from './phone';
import platform from './platform';
import plan from './plan';
import fileSize from './fileSize';

const formatters = [
    //
    date,
    currency,
    phone,
    platform,
    plan,
    fileSize,
];

export const format = (value, format, locale = navigator.language, options) => {
    for (const formatter of formatters) {
        const result = formatter(value, format, locale, options);

        if (result !== undefined) {
            return result;
        }
    }

    return value;
};
